import { DEFAULT_EXPERIENCES_VALUE } from '@shared/models/experience-filter';

import { JobConfig } from './job.abstract.config';

export const jobConfig: JobConfig = {
  privileges: {
    greenhouse: {
      prospect: 'prospect',
    },
    assigned: { // TODO(MOJAT-3794): rename to shortlist after deploying epic
      candidates: 'web:assigned-candidates',
      jobs: 'web:assigned-jobs',
    },
    associate: {
      candidate_to_job: 'web:associate-candidate-to-job',
      jobs_to_candidate: 'web:associate-jobs-to-candidate',
    },
    job: {
      view: 'web:jobs-view',
      create: 'web:jobs-create',
      edit: 'web:jobs-edit',
      notes: 'web:jobs-notes',
      files: 'web:jobs-files',
      publish: 'web:jobs-publish',
      teamMembers: {
        view: 'web:jobs-team-members-view',
        edit: 'web:jobs-team-members-edit',
      },
      budgetInfo: 'web:jobs-budget-info',
    },
    hiringManager: 'hiring-manager',
  },
  filter: {
    experience: DEFAULT_EXPERIENCES_VALUE
  }
};
